import React from 'react';
import {
  Grid,
  Icon,
  makeStyles,
  createStyles,
  Container,
  Theme,
  Typography,
  Box,
  Divider,
} from '@material-ui/core';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import { Link } from 'gatsby-theme-material-ui';

import { OutboundLink } from "gatsby-plugin-google-analytics"

type SocialItem = {
  label: string;
  link: string;
  icon: JSX.Element;
};

type SocialChannels = 'facebookPage' | 'twitter' | 'instagram' | 'linkedIn';

const SOCIAL_LINKS: Record<SocialChannels, SocialItem> = {
  facebookPage: {
    label: 'Facebook page',
    link: 'https://www.facebook.com/habfit.io',
    icon: <FacebookIcon fontSize="inherit" />,
  },
  twitter: {
    label: 'Twitter profile',
    link: 'https://twitter.com/habfit_official',
    icon: <TwitterIcon fontSize="inherit" />,
  },
  instagram: {
    label: 'Instagram profile',
    link: 'https://www.instagram.com/habfit',
    icon: <InstagramIcon fontSize="inherit" />,
  },
  linkedIn: {
    label: 'LinkedIn profile',
    link: 'https://www.linkedin.com/company/habfit-official',
    icon: <LinkedInIcon fontSize="inherit" />,
  },
};

const socialEntries = Object.entries(SOCIAL_LINKS);

const useStyles = makeStyles(({ spacing, palette }: Theme) =>
  createStyles({
    root: {
      padding: spacing(2),
      paddingTop: spacing(10),
      paddingBottom: spacing(5),
      backgroundColor: palette.background.default
    },
  })
);

interface Props{
  hideEmail?: boolean;
}

export const BacklinkingFooter:React.FC<Props> = ({hideEmail}) => {
  const classes = useStyles();
  return (
    <Grid className={classes.root} container justify="flex-end">
      <Container disableGutters>
        <Grid container>
          <Grid item xs={6}>
            <Link color="textPrimary" variant="subtitle1" to="/about-us">About</Link>
            <Box mr={2} />
            <Link color="textPrimary" variant="subtitle1" to="/contact">Contact Us</Link>
            <Box mr={2} />
            <Link color="textPrimary" variant="subtitle1" to="/blog">Blog</Link>
            <Box mr={2} />
            <Link color="textPrimary" variant="subtitle1" to="/privacy-policy">Privacy</Link>
            <Box mr={2} />
            <Link color="textPrimary" variant="subtitle1" to="/terms-of-use">{`Terms & Conditions`}</Link>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" flexDirection="column" alignItems="flex-end">
              <Box mb={3} display="flex" flexWrap="wrap" justifyContent="flex-end">
                {socialEntries.map(entry => {
                  const [key, value] = entry;
                  return (
                    <OutboundLink key={key} target="_blank" href={value.link}>
                      <Box m={1} display="inline">
                        <Icon
                          color="inherit"
                          aria-label={value.label}
                          fontSize="large"
                        >
                          {value.icon}
                        </Icon>
                      </Box>
                    </OutboundLink>
                  );
                })}
              </Box>
              {!hideEmail &&(
                  <Box mx={1.5} mb={1}>
                    <OutboundLink href="mailto:team@habfit.io"> <Typography display="inline">team@habfit.io</Typography></OutboundLink>
                  </Box>
                )}
            </Box>
          </Grid>
        </Grid>
        <Box mt={5} />
        <Typography>© 2021 HabFit Technologies Inc.</Typography>
      </Container>
    </Grid>
  );
};
